/**
 * @mhmo91/ican/firestore/binding — entity-authoring subpath.
 *
 * Re-exports just the binding factory so entity files in shared
 * type packages (`packages/types/src/**`) don't transitively pull
 * `node:fs` / `node:path` from the CLI helpers in
 * `@mhmo91/ican/firestore` into FE bundles. The CLI surface stays
 * available from the main subpath for deploy / equivalence-harness
 * code paths.
 *
 * Entity authoring:
 *
 *     import { firestore } from '@mhmo91/ican/firestore/binding';
 *
 *     ...adaptor(firestore({ path: 'orders/{id}' }));
 */
import { FIRESTORE_ADAPTER_TAG, type FirestoreAdapterBinding } from './types.ts';

export const firestoreBinding = (config: {
  readonly path: string;
  readonly hierarchicalGrants?: boolean;
  readonly parents?: Readonly<Record<string, string>>;
  readonly database?: string;
}): FirestoreAdapterBinding => ({
  _adapter: FIRESTORE_ADAPTER_TAG,
  path: config.path,
  ...(config.hierarchicalGrants === undefined ? {} : {hierarchicalGrants:config.hierarchicalGrants}),
  ...(config.parents === undefined ? {} : { parents: config.parents }),
  ...(config.database === undefined ? {} : { database: config.database }),
});

export { firestoreBinding as firestore };
export type { FirestoreAdapterBinding };
